import { useState, useContext } from "react";
import { useFormik } from "formik";
import { mensajeSimple, mensajeEstatico, modalCargando, modalComentario, modalEjecutar } from "../../components/ui/sweetAlerts";
import { ACEPTA_CAMBIO_CARGO, objStyleCol, RECHAZA_CAMBIO_CARGO } from "../../utils/Constants";
import { validaGetStatus, cerrarSession, hideSideBarDesktop } from "../../utils/funciones";
import { DataContext, DataContextContractual } from "../../contextData/contextData";
import { faEye, faHistory } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CambioCargo } from "../cambio-de-cargo/CambioCargo";
import { getUno, postWithResponse } from "../../api/apis";
import { cierraModal } from "../../utils/funciones";
import { useLocation } from "react-router-dom";
import { ModalBody } from "./modalBody";
import { useIndex } from "../useIndex";
import Swal from "sweetalert2";
import moment from "moment";

export const removerDataInnecesaria = obj => {
  let obj_n = JSON.parse(JSON.stringify(obj));
  if (![4].includes(obj.id_tipo_solicitud)) {
    delete obj_n.tipo_cambio_contrato
  }

  return obj_n
}

export const Celda = props => {
  const { label, ancho } = props;
  return (
    <div
      style={{
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        width: ancho,
      }}
      title={label}
    >
      {label}
    </div>
  )
}

export const CeldaHeader = ({ alineacion, label }) => {
  return (
    <div
      style={{
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        textAlign: alineacion || "left",
        width: "100%",
      }}
      title={label}
    >
      {label}
    </div>
  )
}

export const useSolicitudesCurso = () => {
  const { dataListado, setDataListado, setVisibleModalForm, dataModalForm, setDataModalForm, diasAnticipo } = useContext(DataContextContractual);
  const { setUno } = useContext(DataContext);
  const [visible, setVisible] = useState(false);
  const [visibleHistorial, setVisibleHistorial] = useState(false);
  const [dataModal, setdataModal] = useState({});
  const [idSolicitud, setIdSolicitud] = useState(undefined);
  const { formatFecha } = useIndex();
  const location = useLocation();
  const [documentos, setDocumentos] = useState([]);

  const objModal = {
  titulo: "Información solicitud - " + dataModal?.tipo_solicitud_cambio_contraactual?.nombre,
    component: <ModalBody obj={dataModal} />
  }

  const traerDocumentos = async (obj) => {
    const resp = await getUno("documentoscambiocc", { "id_solicitud_cc": obj.id }, null);
    if (resp?.status === 200) {
      setDocumentos(resp.data.data || []);
    }
  }

  const returnTipoContrato = (tipo) => ({
    "01": "Indefinido",
    "02": "Fijo"
  }[tipo] || "No especifíca")

  const returnAccesos = (perfil, id_tipo_solicitud, estado) => {
    //"2" -> Jefe de zona
    //"3" -> RRHH
    //"4" -> Admin

    let obj = {}
    const noMatch = 12362;

    if ([1, 2, 4].includes(id_tipo_solicitud)) { //-> [cambio de cargo, cambio de unidad]
      obj = {
        '2': [1],
        '3': [2],
        '4': [noMatch], // un numero escandaloso para que no haga match y no tenga acceso
      }
    }

    if ([3].includes(id_tipo_solicitud)) { //-> [cambio de instalacion]
      obj = {
        '2': [6],
        '3': [10],
        '4': [1],
      }
    }

    if ([5].includes(id_tipo_solicitud)) {
      obj = {
        '2': [noMatch],
        '3': [1],
        '4': [noMatch],
      }
    }
    return obj[perfil]?.includes(estado) ? true : false;
  }

  const hideModal = (obj) => {
    setdataModal(obj);
    setVisible(!visible);
  }

  const filtrarUno = (obj) => {
    setDataModalForm({ ...dataModalForm, component: <CambioCargo tipo={1} /> });
    if (obj) {
      formik.setValues({ ...formik.values, fecha_inicio_cambio: formatFecha(obj.fecha_inicio_cambio.replace(/-/g, '')) });
      setUno({
        "REEO_NOMBRES": obj.persona.nombre,
        "REEO_APELLIDO_PATERNO": obj.persona.apellido_pat,
        "REEO_TIPO_CONTRATO": obj.persona.tipo_contrato,
        "REEO_RUT": obj.persona.identificacion,
        "ID": obj.id,
        "FECHA_INICIO_CAMBIO": obj.fecha_inicio_cambio,
      });

      return;
    }
    setUno(undefined);
  }

  const validate = (obj) => {
    let errObj = {};

    if (!["01"].includes(obj.fecha_inicio_cambio.split("-")[2])) errObj.fecha_inicio_cambio = 'Solo primer día (01) de cada mes';
    if (
      moment(formik.values.fecha_inicio_cambio).diff(moment(new Date()).subtract(diasAnticipo, "d"), "days")
      <
      moment(formik.values.fecha_inicio_cambio).diff(moment(formik.values.fecha_inicio_cambio).subtract(diasAnticipo, "d"), "days")
    ) {
      errObj.fecha_inicio_cambio = 'Fecha fuera de rango. Validar con Remuneraciones.';
    }

    if (!obj.cod_sap_nuevo_cargo) errObj.cod_sap_nuevo_cargo = 'Requerido';
    if (!obj.nueva_unidad_organizativa) errObj.nueva_unidad_organizativa = 'Requerido';
    if (!obj.nuevo_plan_horario) errObj.nuevo_plan_horario = 'Requerido';

    return errObj;
  }

  const formik = useFormik({
    initialValues: {
      fecha_inicio_cambio: '',
      cod_sap_nuevo_cargo: '',
      nueva_unidad_organizativa: '',
      nuevo_plan_horario: '',
    },
    validate,
  });

  const aceptaSolicitud = (props) => {
    if (["/solicitudes-traspaso"].includes(location.pathname) && [1].includes(props.id_estado_solicitud)) { //solicitud de traspaso(3) && estado inicial(1)
      cierraModal();
      hideModal();
      filtrarUno(props);
      setVisibleModalForm(true);
      setDataModalForm({
        titulo: "Datos de nueva instalación",
        component: <CambioCargo tipo={1} />,
      });
      return
    }
    modalEjecutar(() => { enviarData(props, false, false, "") }, ACEPTA_CAMBIO_CARGO, props);
  }

  const enviarData = async (obj, data1, data2, res) => {
    modalCargando([4].includes(obj.id_estado_solicitud) ? "Enviando a SAP..." : "Guardando cambios...");
    if (obj.aprueba) { cierraModal(); }

    const resp = await postWithResponse('getlistado', {}, { ...removerDataInnecesaria(obj), observacion: res });
    const validacion = validaGetStatus(resp.status);

    if (validacion) {
      if (!obj.acepta) {
        mensajeSimple(resp.data?.status || "success", resp.data?.message || "Operación exitosa");
        setTimeout(() => { setDataListado({ ...dataListado, arrData: dataListado.arrData.filter(e => e.id !== obj.id) }); }, 1000);

        if (["/solicitudes-traspaso"].includes(location.pathname)) {
          setTimeout(() => { window.location.reload() }, 2000);
        }
      }
      return
    }
    
    // Aquí usamos resp.data.message si viene, sino un texto por defecto o la data cruda.
    const errorMsg = resp?.data?.message || (resp?.data?.data ? JSON.stringify(resp.data.data, null, 2) : "Error en el servidor");
    mensajeEstatico(resp?.data?.status || "error", "", errorMsg);

    if (["/solicitudes-traspaso"].includes(location.pathname)) {
      setTimeout(() => { window.location.reload() }, 2000);
    }
  }

  const rechazaSolicitud = (props) => {
    modalComentario(enviarData, RECHAZA_CAMBIO_CARGO, props);
  }

  const arrColumnas = [
    // {
    //   name: "ID Solicitud",
    //   selector: row => row.id,
    //   width: "100px"
    // },
    {
      name: "Colaborador",
      cell: row => <Celda label={row.persona.nombre + " " + row.persona.apellido_pat + " " + row.persona.apellido_mat} ancho='300px' />,
      width: "250px"
    },
    {
      name: <CeldaHeader label="RUT" alineacion="center" />,
      selector: row => row.persona.identificacion,
      width: "90px",
      style: objStyleCol
    },
    {
      name: "Cargo actual", // <--- anteriormente ID Temporis
      cell: row => <Celda label={row.nombre_cargo_actual.split("|")[1]} ancho='230px' />,
      wrap: false,
      width: "230px",
    },
    {
      name: "Nuevo Cargo Temporis",
      cell: row => <Celda label={row.descripcion_unidad_temporis.split(" - ")[1]} ancho='200px' />,
      width: "200px"
    },
    {
      name: <CeldaHeader label="Fecha inicio cambio" alineacion="center" />,
      selector: row => row.fecha_inicio_cambio ? formatFecha(row.fecha_inicio_cambio.replace(/-/g, '')) : "---",
      width: "160px",
      style: objStyleCol
    },
    {
      name: "Tipo solicitud",
      cell: row => <Celda label={row.tipo_solicitud_cambio_contraactual.nombre} ancho='200px' />,
      width: "200px"
    },
    {
      name: "Estado actual",
      cell: row => <Celda label={row.estado_solicitud_cambio_contractual.nombre} ancho='230px' />,
      width: "230px"
    },
    {
      name: 'Acciones',
      width: "120px",
      button: true,
      cell: (row) => {
        return (
          <>
            {(location.pathname === "/historial-solicitudes") ?
              <button
                className={`btn gap-2 d-flex align-items-center py-0 btn-outline-secondary btn-sm`}
                data-bs-toggle="tooltip" title="Ver historial"
                onClick={() => {
                  setIdSolicitud(row.id);
                  setVisible(!visible);
                }}
              >
                Historial <FontAwesomeIcon icon={faHistory} />
              </button>
              :
              <button
                className={`btn gap-2 d-flex align-items-center py-0 btn-${returnAccesos(localStorage.getItem("id_perfil"), row.id_tipo_solicitud, row.id_estado_solicitud) === false ? "outline-secondary" : "primary"} btn-sm`}
                data-bs-toggle="tooltip" title="Ver solicitud"
                onClick={() => { hideModal(row) }}
              >
                VER<FontAwesomeIcon icon={faEye} title='Ver solicitud' />
              </button>
            }
          </>
        )
      },
    },
  ]

  const traerListado = async (tipo) => {
    const respListado = await getUno(
      ["/", "/historial-solicitudes"].includes(location.pathname) ? "getlistado" : "getallporenviarsap",
      ["/envio-a-sap"].includes(location.pathname) && tipo ? ({ tipo_solicitud: tipo }) : null
    );

    hideSideBarDesktop();

    if (!validaGetStatus(respListado)) {
      cerrarSession();
      return;
    }

    const columnass = !["/envio-a-sap"].includes(location.pathname) ? arrColumnas : arrColumnas.slice(0, -1);

    setDataListado({
      arrData: respListado.data.data,
      id_columnas: columnass,
    });
    Swal.close();
  }

  return {
    objModal, visible, hideModal, aceptaSolicitud, rechazaSolicitud, idSolicitud, setIdSolicitud, traerDocumentos, documentos,
    traerListado, setDataListado, arrColumnas, returnAccesos, returnTipoContrato, visibleHistorial, setVisibleHistorial
  }
}